import { render } from "./ProWelcomeModal.vue?vue&type=template&id=3b4a956a&scoped=true"
import script from "./ProWelcomeModal.vue?vue&type=script&lang=js"
export * from "./ProWelcomeModal.vue?vue&type=script&lang=js"

import "./ProWelcomeModal.vue?vue&type=style&index=0&id=3b4a956a&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4a956a"]])

export default __exports__